import React from "react";

export const ListProjects = React.lazy(() => import("./ListProjects"));
export const ViewProject = React.lazy(() => import("./ViewProject"));
